import { useEffect, useState } from 'react';
import type { LucideIcon } from 'lucide-react';
import { getHomeCategories } from '../services/categories';
import type { HomeCategoryItem } from '../types/homeCategory';
import { sidebarCategories } from '../pages/website/homeData';

const fallbackCategories: HomeCategoryItem[] = sidebarCategories.map((item, index) => ({
  id: -(index + 1),
  name: item.name,
  slug: item.name.toLowerCase().replace(/\s+/g, '-'),
  image: null,
  icon: item.icon,
}));

export function useHomeCategories() {
  const [categories, setCategories] = useState<HomeCategoryItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [activeId, setActiveId] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await getHomeCategories();
        if (cancelled) return;
        const list = data.length > 0 ? data : fallbackCategories;
        setCategories(list);
        setActiveId(list[0]?.id ?? null);
      } catch {
        if (!cancelled) {
          setCategories(fallbackCategories);
          setActiveId(fallbackCategories[0]?.id ?? null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const activeCategory = categories.find((c) => c.id === activeId) ?? null;

  return {
    categories,
    loading,
    activeId,
    activeCategory,
    setActiveId,
  };
}

export type { HomeCategoryItem, LucideIcon };
